const mobileWidth = 767;

const desktopWidth = 1200;

export default {
    mobileWidth,
    desktopWidth
};
